import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrderService } from '../../../_services/order.service';
import { Address } from '../../../_interfaces/address';
import { CommonModule } from '@angular/common';
import { InvoiceService } from '../../../_services/invoice.service';
import { AlertService } from '../../../_services/alert.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from '../../../../Shared/_components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-view-order-modal',
    imports: [CommonModule, MatProgressSpinnerModule, FormsModule],
    templateUrl: './view-order-modal.component.html',
    styleUrl: './view-order-modal.component.css'
})
export class ViewOrderModalComponent {
  order: any;
  billingAddress?: Address;
  shippingAdress?: Address;
  sendPayLinkProgress: boolean = false;
  readonly dialogRef = inject(MatDialogRef<ViewOrderModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialog = inject(MatDialog);
  
  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private invoiceService: InvoiceService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.loadOrderData();
  }

  onGetFormatFromSKU(sku: string): string {
    const parts = sku.split('-');
    return parts[parts.length - 1];
  }

  onInvoiceDownload() {
    let isVatDiscounted  = false;
    this.order.OrderCoupons.forEach((coupon: any) => {
      if (coupon.couponCode === 'VATEXEMP') {
        isVatDiscounted = true;
      }
    });
    this.invoiceService.getInvoice(this.order,isVatDiscounted);
  }

  onSendPaymentLink() {
    this.sendPayLinkProgress = true;
    this.orderService.sendPaymentLink(this.order.orderId).subscribe({
      next: (response) => {
        this.sendPayLinkProgress = false;
        this.alertService.alert("Payment link sent to customer", 'success');
      },
      error: (error) => {
        this.sendPayLinkProgress = false;
        this.alertService.alert(error.error.message, 'error');
      }
    });
  }

  onUpdateOrder(orderItem: any) {
    this.orderService.updateOrderItemStore(orderItem.id, orderItem.store).subscribe({
      next: (response) => {
        this.alertService.alert("Order store Updated", 'success');
      }, 
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      }
   });
  }

  onStatusUpdate() {
    let modelConfig: any = {
      data: {
        title: "Status change confirmation",
        message: "Are you sure?"
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if(result.confirmation) {
        this.orderService.updateOrderStatus(this.order.orderId, this.order.orderStatus).subscribe({
          next: (response) => {
            this.alertService.alert("Order status Updated", 'success');
          }, 
          error: (error) => {
            this.alertService.alert(error.error.message, 'error');
          }
       });
      }
    });
  }

  private async loadOrderData() {
    const orderId = this.data.orderId;
    if (orderId) {
      await this.orderService.getOrderById(Number(orderId)).subscribe(
        (response) => {
          this.order = response;
          if (
            this.order?.OrderAddresses &&
            this.order?.OrderAddresses.length > 0
          ) {
            this.billingAddress = this.order?.OrderAddresses.find(
              (a: any) => a.addressType == 'BILLING'
            );
            this.shippingAdress = this.order?.OrderAddresses.find(
              (a: any) => a.addressType == 'SHIPPING'
            );
          }
        },
        (error) => {
          this.alertService.alert(error.error.message, 'error');
        }
      );
    }
  }
}
